export default "__VITE_ASSET__y1WGMmvO__"